require('./blocks/catalog.less');
require('./blocks/news/news');
// require('./blocks/rating-stars/rating-stars');
require('./blocks/rating-stars-list-inline/rating-stars-inline');
require('./blocks/pagination.less');
require('./blocks/brochure.less');
require('./blocks/brochure-slider/brochure-slider');

require('./plugins/jquery.loader/require.js');
require('./blocks/tutorials/tutorials.js');



// WEBPACK FOOTER //
// ./articles.js